import {
  ODataHeader,
  ODataString,
  ODataBoolean,
  ODataDate,
  ODataInteger,
  ODataDecimal,
  ODataDateTime,
  ODataEnum
} from "pbas-vue-components";
import { translate } from "../trans";
import store from "@/store";
import { translate2 } from "../trans2";
import { i18n } from "@/plugins/i18n";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

function getHeaders(enums) {
  console.log(enums);
  const headers = [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      sortable: true,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
      version: 1,
    }),
    new ODataHeader({
      type: new ODataString("PaymentId"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "components.plancreationwizard.membereligibility.period",
      type: new ODataInteger("CalendarYear", {
        getString: (item, type) => `${item.CalendarMonth} ${item.CalendarYear}`,
      }),
      sortable: true,
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      version: 2,
      subHeaders: [ new ODataHeader({
        title: "headers.eligibility_bank.calendar_month",
        type: new ODataInteger("CalendarMonth"),
        visible: false,
        allowVisibilityChange: false,        
      })]
    }),
    new ODataHeader({
      title: "headers.eligibility_bank.calendar_month",
      type: new ODataInteger("CalendarMonth"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      version: 1,
    }),
    new ODataHeader({
      title: "headers.selfpayments.payment_date",
      type: new ODataDate("PaymentDate"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
    new ODataHeader({
      title: "globals.amount",
      type: new ODataDecimal("Amount", {
        getString: (item, type) => {
          const value = item.Amount;
          if (value === null || value === undefined) {
            return "";
          }
          if (typeof value !== "number") {
            return value;
          }
          return formatter.format(value);
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.selfpayments.deposited",
      type: new ODataBoolean("Deposited"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "views.planbalance.cheque_number",
      type: new ODataString("PaymentNumber"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.selfpayments.payment_type",
      type: new ODataEnum("Type", {
        getString: (item) => {
          return i18n.t("enums." + item.Type);
        },
        dropdownItems: enums.PaymentType,
      }),

      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.trigger",
      type: new ODataString("User"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.timestamp",
      type: new ODataDateTime("Timestamp"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
  ];
  return headers;
}
export default getHeaders;
